import NavBar from './NavBar/NavBar';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import LandingPage from './LandingPage/LandingPage';


const Layout = () => {
	return (
		<>
			<div className='min-h-screen w-full md:w-1/2 mx-auto font-sans text-sm'>
				<NavBar />
				<Outlet />
			</div>
		</>
	);
};

const router = createBrowserRouter([
	{
		element: <Layout />,
		children: [
			{
				path: '/',
				element: <LandingPage />,
			},

		],
	},
]);

const App = () => {
	return <RouterProvider router={router} />;
};

export default App;
